import React from 'react';
import { IconCheckmarkCircle, IconError, IconInfo, IconMinusCircle, IconWaiting, IconWarning } from '../components/Icon/index';

/**
 * Returns an icon based on appearance.
 *
 * @param {object} props
 * @param {string} props.appearance - One of "success", "warning", "error", "info", "transient"
 */
// eslint-disable-next-line zillow/react/prop-types
export var statusIconAppearance = function statusIconAppearance(_ref) {
  var appearance = _ref.appearance;
  switch (appearance) {
    case 'success':
    case 'complete':
      return /*#__PURE__*/React.createElement(IconCheckmarkCircle, null);
    case 'warning':
      return /*#__PURE__*/React.createElement(IconWarning, null);
    case 'error':
      return /*#__PURE__*/React.createElement(IconError, null);
    case 'info':
      return /*#__PURE__*/React.createElement(IconInfo, null);
    case 'transient':
      return /*#__PURE__*/React.createElement(IconWaiting, null);
    case 'incomplete':
      return /*#__PURE__*/React.createElement(IconMinusCircle, null);
    default:
      return null;
  }
};